import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import { APP } from '../config/app';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | sent | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    if (!email.trim()) {
      setErrorMsg('Please enter your email address.');
      return;
    }
    setStatus('submitting');
    try {
      await authAPI.forgotPassword(email.trim());
      // Always show "sent" regardless — prevents user enumeration
      setStatus('sent');
    } catch {
      setErrorMsg('The reset email could not be sent just now. Check your connection and try again.');
      setStatus('idle');
    }
  };

  return (
    <div className="setup-password-page">
      <div className="setup-password-card">
        <img
          src={`${APP.basePath}/ncadLogo.gif`}
          alt="NCAD"
          className="setup-password-logo"
        />
        <h1 className="setup-password-title">Reset Password</h1>

        {status !== 'sent' ? (
          <>
            <p className="setup-password-welcome">
              Enter your email address and we'll send you a reset link valid for 1 hour.
            </p>
            <form className="setup-password-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="fp-email">Email Address</label>
                <input
                  id="fp-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="your@email.com"
                  autoFocus
                  required
                  disabled={status === 'submitting'}
                />
              </div>
              {errorMsg && <p className="setup-password-field-error">{errorMsg}</p>}
              <button
                type="submit"
                className="btn btn-primary"
                disabled={status === 'submitting'}
                style={{ width: '100%', marginTop: '0.5rem' }}
              >
                {status === 'submitting' ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div className="setup-password-done">
            <p style={{ marginBottom: '0.5rem' }}>
              Check your inbox — if <strong>{email}</strong> is registered you'll receive a reset link shortly.
            </p>
            <p style={{ fontSize: '0.875rem', color: 'var(--text-tertiary)' }}>
              The link expires in 1 hour. Check your spam folder if it doesn't arrive.
            </p>
          </div>
        )}

        <button
          type="button"
          className="btn unstyled"
          onClick={() => navigate('/')}
          style={{ marginTop: '1.5rem', fontSize: '0.875rem', color: 'var(--text-tertiary)', cursor: 'pointer', background: 'none', border: 'none' }}
        >
          ← Back to Sign In
        </button>
      </div>

      <style>{`
        .setup-password-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--surface-page);
          padding: 2rem;
        }
        .setup-password-card {
          background: var(--surface-base);
          border-radius: 12px;
          box-shadow: var(--shadow-md);
          padding: 2.5rem 2rem;
          width: 100%;
          max-width: 420px;
          text-align: center;
        }
        .setup-password-logo {
          height: 56px;
          margin-bottom: 1.5rem;
        }
        .setup-password-title {
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 0 1rem;
        }
        .setup-password-welcome {
          color: var(--text-secondary);
          margin-bottom: 1.5rem;
          font-size: 0.95rem;
          line-height: 1.5;
        }
        .setup-password-form {
          text-align: left;
        }
        .setup-password-form .form-group {
          margin-bottom: 1rem;
        }
        .setup-password-form label {
          display: block;
          font-weight: 500;
          margin-bottom: 0.35rem;
          font-size: 0.875rem;
        }
        .setup-password-field-error {
          color: var(--color-error);
          font-size: 0.875rem;
          margin: 0.25rem 0 0.5rem;
        }
        .setup-password-done {
          color: var(--text-primary);
          line-height: 1.6;
        }
      `}</style>
    </div>
  );
}
